import {Component, computed, input, model} from '@angular/core';
import {ModelFieldSelectButtonComponent} from '../model-field-select-button/model-field-select-button.component';

@Component({
  selector: 'app-model-field-select-inclusion',
  imports: [ModelFieldSelectButtonComponent],
  templateUrl: './model-field-select-inclusion.component.html',
})
export class ModelFieldSelectInclusionComponent {
  id = input.required<string>();
  label = input<string>('');
  tooltipKey = input<string>('');
  isReadOnly = input<boolean>(false);

  value = model<boolean | null>(null);

  protected readonly options = computed(() => {
    const value = this.value();

    return [
      {
        key: 'project.steps.included',
        value: true,
        icon: value === true ? 'pi pi-check-circle text-green' : 'pi pi-circle',
      },
      {
        key: 'project.steps.excluded',
        value: false,
        icon: value === false ? 'pi pi-times-circle text-button-red' : 'pi pi-circle',
      },
    ];
  });
}
